import React from 'react'

import {
  Box,
  Grid,
  Link,
  Typography,
} from '@mui/material'

const LandingHeader = (props) => {
  return (
    // <Box sx={{ bgcolor: '#655dc6', height: 512 }}>
    <Box sx={{ height: 512, width: '100%' }} style={{ backgroundImage: `url('/assets/images/header-background.png')`, backgroundSize: 'cover' }}>
      <Box sx={{ display: 'flex', height: '100%' }}>
        <Box sx={{ flexGrow: 1 }} p={4} m='auto'>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography color='white' variant='h4'>
                <b>Una nueva forma de <span style={{ color: '#00c08b' }}>aprender en equipo</span> con los estudiantes y profesores</b>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', }}>
                <Link href='https://apps.apple.com/us/app/lightspot/id1640747345' target='_blank'>
                  <Box
                    component='img'
                    src='/assets/images/app-store-badge.svg'
                    sx={{ m: 1, height: 78, width: 200 }}
                  />
                </Link>
                <Link href='https://play.google.com/store/apps/details?id=com.senorgato.lightspot' target='_blank'>
                  <Box
                    component='img'
                    src='/assets/images/google-play-badge.png'
                    sx={{ m: 1, width: 200 }}
                  />
                </Link>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box px={6} sx={{ display: { xs: 'none', md: 'block' } }}>
          <Box
            component='img'
            src='/assets/images/heading_girl.png'
            alt='Alumna'
            sx={{ height:'100%' }}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default LandingHeader